import React, { FC } from 'react';
import '@redoc/ui-kit/style.css'; 
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import api from './API';
import { ErrorBoundary } from './Containers';

const DefaultLogoutUrl = "/login";

const Login = React.lazy(() => import('./Pages/Login'));
const Config = React.lazy(() => import('./Pages/Config'));
const PortalLayout = React.lazy( () => import('./Layers/Portal') );
const Widget = React.lazy( () => import('./Layers/Widget/Widget') );
const Admin = React.lazy( () => import('./Layers/Admin/Admin') );
const PrintLayoute = React.lazy( () => import('./Layers/Print/PrintLayout') );
const PdfViewer = React.lazy( () => import('./Views/PdfViewer/PdfViewer') );
const Help = React.lazy( () => import('./Views/Help/Help') );

/** Обертка над роутами доступными только авторизированным пользователям  */
const PrivateRoute = ({ children }: { children: JSX.Element }) => {
	const isAuth = api.Auth.isAuthenticated();
	if ( !isAuth ) {
		const to = `${DefaultLogoutUrl}${window.location.search}`;
		return <Navigate to={to} state={{ from: window.location.href.split('?')[0] }} />;
	}
	return children;
};

const InnerApp: FC = () =>  (
	<HashRouter future={{ v7_startTransition: true }}>
		<Routes>
			<Route path='/login' id='Login Page' element={<Login />} />
			<Route path="/cfg" element={<PrivateRoute><Config /></PrivateRoute>} />
			<Route path='/widget/*' id='widget' element={<Widget />} />
			<Route path="/portal/*"	element={<PrivateRoute><PortalLayout /></PrivateRoute>}	/>
			<Route path='/admin/*' element={<PrivateRoute><Admin /></PrivateRoute>} />
			<Route path='/print/:type' element={<PrivateRoute><PrintLayoute /></PrivateRoute>} />
			<Route path='/print/:type/:id' element={<PrivateRoute><PrintLayoute /></PrivateRoute>} />
			<Route path="/pdf/:path" element={<PdfViewer />} />
			<Route path="/printPdf/:path" element={<PdfViewer autoPrint />} />
			<Route path="/previewPdf/:path" element={<PdfViewer />} />
			<Route path="/help" element={<Help />} />
			<Route path="*"	element={ <Navigate to='/portal/fileList' /> } />
		</Routes>
	</HashRouter>
);

const App = () => {
	// Пока что выпилил компонент для отлавливания ошибок 
	if ( window.isDev ) 
		return ( <InnerApp /> );
	else 
		return (
			<ErrorBoundary>
				<InnerApp />
			</ErrorBoundary>
		);
};

export default App;
